import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin, onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
import { getLogsInitConfig } from '@modules/monitoring/logs';
import { getRumInitConfig } from '@modules/monitoring/rum';

// Re-exported so Next.js can call it during App Router client-side navigations.
// See: https://github.com/DataDog/browser-sdk/blob/main/packages/rum-nextjs/README.md
export { onRouterTransitionStart };

const rumInitConfig = getRumInitConfig();
if (rumInitConfig) {
  datadogRum.init({
    ...rumInitConfig,
    plugins: [nextjsPlugin()],
  });
}

const logsInitConfig = getLogsInitConfig();
if (logsInitConfig) {
  datadogLogs.init(logsInitConfig);
}
